/*
 * @Description: 收款报表详情
 * @Author: 李镇鹏
 * @Date: 2019-06-24 10:41:42
 * @LastEditTime: 2019-07-01 19:54:03
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { Form,Button,message,Col, Row,Input } from 'antd';
import SuperForm from '../../../../components/SuperForm';
import TableDOM from '../../../../components/Table';
import AuthButton from '../../../../components/AuthButton/AuthButton';
import { post, config, transterQuery } from '../../../../axios';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import ModalDom from '../../../../components/Modal';
import {dicPayChannel, dicPayType, ReceivablesType} from '../../../../axios/dictionaries';
import moment from 'moment';
import {handleExportParams, moneyAddComma} from '../../../../utils';

class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                customerName: '',
                customerPhone: '',
                feeName: '',
                houseId: '',
                orderNoThird: '',
                payChannel: '',
                payType: '',
                startDate: '',
                endDate: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableTotalMny: 0, //表格总金额
            showSigningModal: false, //显示签约
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadPack = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            current = values.current
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true,current });

        post({ url: config.API_report_findReportTradeRecordInfo, data }).then(res => {
            this.setState({ tableTotalMny: res.money,tableTotal: res.total, tableData: res.tradeRecord, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    render() {
        let {
            current,
            tableData,
            tableLoading,
            tableTotal,
            tableTotalMny,
            params
        } = this.state;
        let { visible, handleCancel, form: { getFieldDecorator } } = this.props;

        return (
            <ModalDom
                title="详情"
                width="980px"
                loading={tableLoading}
                visible={visible}
                onCancel={()=>{
                    handleCancel();
                    this.setState({
                        params:{ //搜索参数
                            customerName: '',
                            customerPhone: '',
                            mustPayDate:'',
                            feeName: '',
                            houseId: '',
                            customerId:'',
                            orderNoThird: '',
                            payChannel: '',
                            payType: '',
                            // startDate: '',
                            // endDate: '',
                            pageSize: 10,
                        }
                    })
                }}
                footer={
                    <Button onClick={()=>{
                        handleCancel();
                        this.setState({
                            params:{ //搜索参数
                                customerName: '',
                                customerPhone: '',
                                mustPayDate:'',
                                feeName: '',
                                houseId: '',
                                orderNoThird: '',
                                payChannel: '',
                                payType: '',
                                // startDate: '',
                                // endDate: '',
                                pageSize: 10,
                            }
                        })
                    }}>关闭</Button>
                }
            >
                <div className="custom">
                    <Form labelCol={{ span: 0 }}
                          wrapperCol={{ span: 24 }}>
                        <Row>
                            <Col>
                                <DetailTitle title="房源" boxStyle={{ marginTop: 0 }} />
                                <CustomRow>
                                    <CustomCol label="楼栋" required={false} >
                                        {getFieldDecorator('buildingName', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: params.buildingName
                                        })(
                                            <Input
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                    <CustomCol label="房间号" required={false} >
                                        {getFieldDecorator('roomNo', {
                                            rules: [{
                                                required: false, message: '请输入',
                                            }],
                                            initialValue: params.roomNo
                                        })(
                                            <Input
                                                disabled={true}
                                                autoComplete={'off'}
                                            />
                                        )}
                                    </CustomCol>
                                </CustomRow>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <DetailTitle title="查询" />
                <div className="search-wrapper search-wrapper-two" style={{ flexDirection: 'column' }}>
                    <SuperForm
                        onRef={ref => this.superFormRef = ref}
                        data={searchData(params)}
                        sumbit={this.loadPack}
                        addParams={'current'}
                    />
                    <div className="search-btn-list">
                        <AuthButton authkey="c-3-2" type="primary" icon="export" href={`${config.API_report_reportTradeRecordInfoExprotDate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                    </div>
                </div>
                <TableDOM
                    columns={columns()}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    totalMny={tableTotalMny}
                    current={current}
                    onChange={this.loadPack}
                    scroll={{ x: 1200 }}
                />
            </ModalDom>
        )
    }
}

const searchData = (params) => {
    let data = [
        {
            tagName: 'MonthPicker',
            formConfig: { name: 'mustPayDate',options:{initialValue:moment(params.mustPayDate)}},
            attribute: { placeholder: '请选择应收月份',type:'month',format:"YYYY-MM", allowClear:false,style: { width: "172.7px" },disabled :true },
        },
        {
            tagName: 'Select',
            formConfig: { name: 'receiveStatus',options:{initialValue:params.receiveStatus} ,},
            attribute: { placeholder: '已收状态', style: { width: '175px', } ,disabled :true},
            optionData: [{ title: '全部', value: '' },{ title: '历史迁移数据', value: 10 },{ title: '已收数据', value: 3 }],
            notResult: '',
        },
    ];
    return data;
};

const columns = () => [
    {
        title: '应收日期',
        dataIndex: 'mustPayDate',
        width:150
    },
    {
        title: '租客',
        dataIndex: 'customerName',
        width:150,
        render(text, record, index) {
            return <span >
                <div>{record.customerName ? record.customerName : null}</div>
                <div>{record.customerPhone ? record.customerPhone : null}</div>
            </span>
        }
    },
    {
        title: '账单',
        dataIndex: 'feeName',
        width:150,
    },
    {
        title: '账单周期',
        dataIndex: 'billBeginDate',
        width:150,
        render(text, record, index) {
            return <span >
                <div>{record.billBeginDate ? moment(record.billBeginDate).format('YYYY-MM-DD') : null}</div>
                <div>{record.billEndDate ? moment(record.billEndDate).format('YYYY-MM-DD') : null}</div>
            </span>
        }
    },
    {
        title: '应收 | 已收（元）',
        dataIndex: 'receivedMoney',
        width:150,
        render(text, record, index) {
            return <span>
                <div>{moneyAddComma(record.billMoney)}</div>
                {record.receivedMoney ? <div style={{ color: "red" }}>{moneyAddComma(record.receivedMoney)}</div> : null}
            </span>
        }
    },
    {
        title: '账单状态 | 结清日期',
        dataIndex: 'receiveStatus',
        render(text, record, index) {
            let now = ReceivablesType.find(item => item.value === text);
            if (now)
                return <span >
                    <div>{record.historyBill ? "历史迁移" : now.title}</div>
                    <div>{record.finishDate ? moment(record.finishDate).format('YYYY-MM-DD') : null}</div>
                </span>
            return null
        }
    }
];
export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Report/components/Detail/index.js